'use strict';

module.exports = function (value) {
    return value;
};


//////////////////
// WEBPACK FOOTER
// ./~/reactabular/dist-modules/formatters/identity.js
// module id = 957
// module chunks = 0